import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";
import { ScrollSmoother } from "gsap/ScrollSmoother";
import { DrawSVGPlugin } from "gsap/DrawSVGPlugin";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother, DrawSVGPlugin);

document.addEventListener("DOMContentLoaded", () => {
  // Elements
  const bg1 = document.querySelector(".memola-bg-1-gsap");
  const bg2 = document.querySelector(".bg-2-gsap");
  const bg3 = document.querySelector(".memola-bg-3-gsap");

  const text1 = document.querySelector(".gsap-text-1");
  const text2 = document.querySelector(".gsap-text-2");
  const text3 = document.querySelector(".gsap-text-3");

  // Initial positions
  if (bg1) gsap.set(bg1, { x: -100 });
  if (bg2) gsap.set(bg2, { x: 120 });
  if (bg3) gsap.set(bg3, { x: -110 });

  if (text1) gsap.set(text1, { y: -110, opacity: 0.4 });
  if (text2) gsap.set(text2, { y: -110, opacity: 0.4 });
  if (text3) gsap.set(text3, { y: -110, opacity: 0.4 });

  // Animations
  if (bg1)
    gsap.to(bg1, {
      x: 0,
      scrollTrigger: {
        trigger: bg1,
        start: "top 95%",
        end: "top 50%",
        scrub: 2.5,
      },
    });
  if (bg2)
    gsap.to(bg2, {
      x: 0,
      scrollTrigger: {
        trigger: bg2,
        start: "top 95%",
        end: "top 50%",
        scrub: 2.2,
      },
    });
  if (bg3)
    gsap.to(bg3, {
      x: 0,
      scrollTrigger: {
        trigger: bg3,
        start: "top 80%",
        end: "top 20%",
        scrub: 2.6,
      },
    });

  if (text1)
    gsap.to(text1, {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: text1,
        start: "top 80%",
        end: "top 20%",
        scrub: 1.9,
      },
    });
  if (text2)
    gsap.to(text2, {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: text2,
        start: "top 80%",
        end: "top 20%",
        scrub: 1.9,
      },
    });
  if (text3)
    gsap.to(text3, {
      y: 0,
      opacity: 1,
      scrollTrigger: {
        trigger: text3,
        start: "top 80%",
        end: "top 20%",
        scrub: 1.9,
      },
    });
});

// Window load animations
window.addEventListener("load", () => {
  const sections = gsap.utils.toArray(".link-item-section");
  const image = document.querySelector(".center-image-radius");
  const triggerElement = document.querySelector(".link-items-animation-pin");

  if (sections.length && triggerElement) {
    const mm = gsap.matchMedia();

    mm.add("(min-width: 576px)", () => {
      gsap.set(sections, { opacity: 0, y: 50 });
      if (image)
        gsap.set(image, { scale: 0.8, borderRadius: "444px", bottom: "-100%" });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: triggerElement,
          start: "top 95%",
          end: "+=180%",
          scrub: 1.2,
        },
      });

      tl.to(sections, { opacity: 1, y: 0, stagger: 0.2, ease: "power4.out" });
      if (image)
        tl.to(
          image,
          { scale: 1, borderRadius: "888px", ease: "power4.out", duration: 2 },
          "<",
        );
    });

    mm.add("(max-width: 575px)", () => {
      sections.forEach((section) => {
        gsap.fromTo(
          section,
          { opacity: 0, y: 30 },
          {
            opacity: 1,
            y: 0,
            duration: 0.6,
            ease: "power3.out",
            scrollTrigger: {
              trigger: section,
              start: "top bottom",
              toggleActions: "play none none reverse",
            },
          },
        );
      });
      ScrollTrigger.refresh();
    });
  }
});

// Background color change
const bodyChangeColor = () => {
  const items = gsap.utils.toArray(".link-item-parallax-body");
  if (!items.length) return;

  items.forEach((item) => {
    const startColor =
      getComputedStyle(item).getPropertyValue("background-color");
    gsap.fromTo(
      item,
      { backgroundColor: startColor },
      {
        backgroundColor: "#ffffff",
        ease: "none",
        scrollTrigger: {
          trigger: item,
          start: "top bottom",
          end: "bottom top",
          scrub: true,
        },
      },
    );
  });
};
document.addEventListener("DOMContentLoaded", bodyChangeColor);

// Parallax link items
const linkItemParalax = () => {
  const items = gsap.utils.toArray(".link-item-parallax");
  if (!items.length) return;

  items.forEach((item) => {
    gsap.fromTo(
      item,
      { opacity: 0, y: 50 },
      {
        opacity: 1,
        y: 20,
        ease: "power4.out",
        scrollTrigger: {
          trigger: item,
          start: "top 95%",
          end: "bottom 80%",
          scrub: 1.5,
        },
      },
    );
  });
};
document.addEventListener("DOMContentLoaded", linkItemParalax);

// Bloob animations
function initBloobAnimations(configs) {
  configs.forEach((sectionConfig) => {
    const { trigger, animations } = sectionConfig;
    const sections = document.querySelectorAll(trigger);
    if (!sections.length) return;

    sections.forEach((section) => {
      animations.forEach((anim) => {
        const elements = section.querySelectorAll(anim.selector);
        if (!elements.length) return;

        elements.forEach((el) => {
          gsap.to(el, {
            ...anim.props,
            scrollTrigger: {
              trigger: section,
              start: anim.start || "top bottom",
              end: anim.end || "bottom top",
              scrub: anim.scrub || 1,
            },
          });
        });
      });
    });
  });
}

const bloobConfigs = [
  {
    trigger: ".section-with-bloobs",
    animations: [
      {
        selector: ".left-bloob .blob-bg",
        props: { y: -20, scale: 1.2, ease: "power4.out" },
        start: "top 50%",
        end: "bottom top",
        scrub: 1.9,
      },
      {
        selector: ".left-bloob .heart",
        props: { y: -60, scale: 1.2, ease: "power4.out" },
        start: "top 50%",
        end: "bottom top",
        scrub: 1.5,
      },
      {
        selector: ".left-bloob .memola-image",
        props: { y: -70, rotate: -10, ease: "power4.out" },
        start: "top 60%",
        end: "bottom top",
        scrub: 1.5,
      },
      {
        selector: ".right-bloob .blob-bg",
        props: { y: 40, ease: "power4.out" },
        start: "top bottom",
        end: "bottom top",
        scrub: 1.5,
      },
      {
        selector: ".right-bloob .memola-image",
        props: { y: 150, x: -70, rotate: 15, ease: "power4.out" },
        start: "top bottom",
        end: "bottom top",
        scrub: 2,
      },
      {
        selector: ".right-bloob-2 .memola-image-2",
        props: { x: -10, scale: 0.9, rotate: -10, ease: "power4.out" },
        start: "top bottom",
        end: "bottom top",
        scrub: 2,
      },
      {
        selector: ".right-bloob-2 .additional-2",
        props: { x: -20, scale: 1.1, rotate: -10, ease: "power4.out" },
        start: "top bottom",
        end: "bottom top",
        scrub: 2,
      },
    ],
  },
];

function handleBloobAnimation() {
  initBloobAnimations(bloobConfigs);
}
document.addEventListener("DOMContentLoaded", handleBloobAnimation);
window.addEventListener("resize", handleBloobAnimation);

// Continuous child animation
const child = () => {
  const element = document.querySelector(".memola-bg-2");
  if (!element) return;

  gsap.fromTo(
    element,
    { rotation: -15 },
    {
      rotation: 15,
      duration: 2,
      yoyo: true,
      repeat: -1,
      ease: "sine.inOut",
      transformOrigin: "50% 0%",
    },
  );
};
document.addEventListener("DOMContentLoaded", child);

// Refresh ScrollTrigger on containers
function refreshOnContainerVisible() {
  const containers = document.querySelectorAll(".container.py-lg-10.py-8");
  if (!containers.length) return;

  const observer = new IntersectionObserver(
    (entries, obs) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          ScrollTrigger.refresh();
          obs.unobserve(entry.target);
        }
      });
    },
    { rootMargin: "0px 0px -50px 0px" },
  );

  containers.forEach((el) => observer.observe(el));
}

window.addEventListener("load", refreshOnContainerVisible);
